module.exports = __webpack_public_path__ + "static/media/seo-bar-chart-icon.0f9a2829.svg";